import {ROLES} from '@/constants/roles'

export default {
  header: 'Usuarios',
  navLink: '/app/users',
  roles: [ROLES.coordinator, ROLES.superadmin],
  children: []
}
